module.exports = __webpack_public_path__ + "static/media/order.37a39f38.png";